import { API } from "./../../../api/config";

export const getEzdParametersAPI = () => {
    return API.get("/pmbpartner/ezd-parameters")
              .then((res) => res);
};

export const updateEzdParametersAPI = (param) => {
    return API.put(`/pmbpartner/ezd-parameters/${param.id}`, param?.payload)
              .then((res) => res);
};